import type { Epic } from '../../index.js'
import { filter, map, merge } from 'rxjs'
import { Actions } from '../../Slice/index.js'
import { orderSlice } from '../../Slice/Order/OrderSlice.js'
import { sendWebSocketMessage } from '../../Slice/Application/ApplicationSlice.js'
import { projectSlice } from '../../Slice/Project/ProjectSlice.js'

export const updateSubscriptionEpic: Epic = (action$) =>
  merge(
    action$.pipe(
      filter(Actions[orderSlice.name].getOrderRequestSuccess.match),
      map(({ payload }) =>
        sendWebSocketMessage({
          type: 'subscription-change',
          subscriptions: [{ type: 'ORDER', id: payload.id }]
        })
      )
    ),
    action$.pipe(
      filter(Actions[orderSlice.name].createOrderSuccess.match),
      map(({ payload }) =>
        sendWebSocketMessage({
          type: 'subscription-change',
          subscriptions: [{ type: 'ORDER', id: payload.id }]
        })
      )
    ),
    action$.pipe(
      filter(Actions[projectSlice.name].getProjectRequestSuccess.match),
      map(({ payload }) =>
        sendWebSocketMessage({
          type: 'subscription-change',
          subscriptions: [{ type: 'PROJECT', id: payload.id }]
        })
      )
    ),
    action$.pipe(
      filter(Actions[projectSlice.name].createProjectRequestSuccess.match),
      map(({ payload }) =>
        sendWebSocketMessage({
          type: 'subscription-change',
          subscriptions: [{ type: 'PROJECT', id: payload.id }]
        })
      )
    )
  )
